package one.healthium.tasks.di

import one.healthium.tasks.ui.DailyTasksViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val dailyTasksUiModule = module {
    includes(dailyTasksModule)
    viewModelOf(::DailyTasksViewModel)
}